import logSystemUtil from '../../../../logs/redux/actions/log'
import afterSaveAssociationReduxHook from '../../../../redux/hooks/after-save-association'
import { getObjectUtil, lastArrayUtil } from 'packages/src'

export default function triggerAfterSaveAssociationHook (params) {
  const {
    instance,
    reference,
    updatedState
  } = params
  // If it's a instance referencing the `instance`
  // run its after save association
  // e.g. `reference` = 'posts.data.-3.changed.attachment'
  const referenceArr = reference.split('.')
  if (referenceArr.length !== 5) {
    return updatedState
  }
  const referenceInstance = getObjectUtil(updatedState, referenceArr.slice(0, 3)
    .join('.'))
  if (!referenceInstance) {
    logSystemUtil('triggerAfterSaveAssociationHook')
      .warn('referenceInstance does not exist')
    return updatedState
  }

  return afterSaveAssociationReduxHook(referenceInstance, updatedState, {
    associationKey: lastArrayUtil(referenceArr),
    association: instance
  })
}
